import React from "react"

import { ProductTenderText } from "entities/products/ui/product-tender-text/ProductTenderText"

import { useProductPositionFormProductInformationContext } from "../contexts/ProductPositionFormProductInformationContext"

export const ProductPositionFormTenderTextTab = React.memo(() => {
  const { productInformation, isLoadingProductInformation: isLoading } =
    useProductPositionFormProductInformationContext()

  return (
    <div className="product-position-form__tab-content product-position-form__tab-content--tender-text">
      <ProductTenderText.Root
        productInformation={productInformation}
        isLoading={isLoading}
      >
        <h3 className="product-position-form__tender-text-title">
          {productInformation?.title}
        </h3>
        <div className="product-tender-text card card--elevated product-position-form__tender-text-card">
          <div className="product-tender-text__content">
            <ProductTenderText.GeneralDescription />
            <ProductTenderText.VariantDescription />
          </div>
          <div className="product-tender-text__footer">
            <ProductTenderText.CopyToClipboard />
          </div>
        </div>
      </ProductTenderText.Root>
      {productInformation?.addons?.map(addon => {
        return (
          <ProductTenderText.Root
            key={addon.variantKey}
            productInformation={addon}
            isLoading={isLoading}
          >
            <h3 className="product-position-form__tender-text-title">
              {addon?.title}
            </h3>
            <div className="product-tender-text card card--elevated product-position-form__tender-text-card">
              <div className="product-tender-text__content">
                <ProductTenderText.GeneralDescription />
                <ProductTenderText.VariantDescription />
              </div>
            </div>
          </ProductTenderText.Root>
        )
      })}
    </div>
  )
})
